import { useTranslation } from 'next-i18next';
import { VFC } from 'react';

import styles from './SwapWithIPFSButton.module.scss';

type Props = {
  onClick(): void;
};

const SwapWithIPFSButton: VFC<Props> = ({ onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      className={styles.swapWithIPFSButton}
    >
      {t('swapWithIPFS.swapWithIPFS')}
    </button>
  );
};

export default SwapWithIPFSButton;
